import { render, staticRenderFns } from "./courseListView.vue?vue&type=template&id=22c00b6f&scoped=true"
import script from "./courseListView.vue?vue&type=script&lang=js"
export * from "./courseListView.vue?vue&type=script&lang=js"
import style0 from "./courseListView.vue?vue&type=style&index=0&id=22c00b6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c00b6f",
  null
  
)

export default component.exports